import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=7e86a19c&scoped=true"
var script = {}
import style0 from "./nodata.vue?vue&type=style&index=0&id=7e86a19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e86a19c",
  null
  
)

export default component.exports